module.exports = __webpack_public_path__ + "img/1536930331.7c4177cd.jpg";